import {
  REPORTS_PSYCHOLOGY_PATH,
  REPORTS_DURATION_PATH,
  REPORTS_TIME_PATH,
  REPORTS_RISK_PATH,
  REPORTS_STRATEGY_PATH,
  REPORTS_INSTRUMENTS_PATH,
  REPORTS_DRAWDOWN_PATH,
  REPORTS_TRADING_CONFLUENCE_PATH,
} from '../../constants'
import AbstractService from '../../services/AbstractService'
import { ServerResponse } from '../../types'

import {
  ReportDto,
  PsychologyType,
  TimeReportType,
  DurationReportType,
  RiskReportType,
  StrategiesType,
  InstrumentsType,
  DrawdownType,
  TradingConfluencesType,
} from './types'

class ReportServiceClass extends AbstractService {
  getTimeReport = (data: ReportDto) =>
    this.request<ServerResponse<TimeReportType>>(REPORTS_TIME_PATH, 'post', true, data)

  getDurationReport = (data: ReportDto) =>
    this.request<ServerResponse<DurationReportType>>(REPORTS_DURATION_PATH, 'post', true, data)

  getPsychologyReport = (data: ReportDto) =>
    this.request<ServerResponse<PsychologyType>>(REPORTS_PSYCHOLOGY_PATH, 'post', true, data)

  getRiskReport = (data: ReportDto) =>
    this.request<ServerResponse<RiskReportType>>(REPORTS_RISK_PATH, 'post', true, data)

  getTradingStrategyReport = (data: ReportDto) =>
    this.request<ServerResponse<StrategiesType>>(REPORTS_STRATEGY_PATH, 'post', true, data)

  getTradingConfluenceReport = (data: ReportDto) =>
    this.request<ServerResponse<TradingConfluencesType>>(
      REPORTS_TRADING_CONFLUENCE_PATH,
      'post',
      true,
      data,
    )

  getInstrumentsReport = (data: ReportDto) =>
    this.request<ServerResponse<InstrumentsType>>(REPORTS_INSTRUMENTS_PATH, 'post', true, data)

  getDrawdownReport = (data: ReportDto) =>
    this.request<ServerResponse<DrawdownType>>(REPORTS_DRAWDOWN_PATH, 'post', true, data)
}

export const ReportService = new ReportServiceClass()
